// extracted by mini-css-extract-plugin
module.exports = {"surveysInfo":"SurveysInfo_surveysInfo__2wYT3","wrapTabs":"SurveysInfo_wrapTabs__2FQou"};